<script>
import {defineComponent} from 'vue'
import DelegateStake from "./Delegate.vue";
// import useWallet
import { useWallet } from 'solana-wallets-vue';



export default defineComponent({
    name: "EthStake",
    components: {DelegateStake},
    data() {
        return {
            wallet: useWallet(),
            user: null,
            ethYield: [],
            solYield: [],
            ethPrices: [],
            solPrices: [],
        }
    },
    mounted() {

    },
    methods: {
        getEthYield() {
            axios.get('https://yields.llama.fi/chart/747c1d2a-c668-4682-b9f9-296708a3dd90').then((response) => {
                this.ethYield = response.data.data
            })
        },
        getEthPrices() {
            // retrieve price data since 2023-01-01 from Coingecko
            axios.get('https://api.coingecko.com/api/v3/coins/ethereum/market_chart/range??vs_currency=usd&days=max&interval=daily').then((response) => {
                // take array of [[timestamp, price]] and convert to dates then filter to 2023
                let prices = response.data.prices
                let filtered = prices.map((price) => {
                    return {date: new Date(price[0]), price: price[1]}
                }).filter((price) => {
                    return price.date.getFullYear() == 2023
                })
                this.ethPrices = filtered
            })
        },
        getSolPrices() {
            // retrieve price data since 2023-01-01 from Coingecko
            axios.get('https://api.coingecko.com/api/v3/coins/solana/market_chart/range??vs_currency=usd&days=max&interval=daily').then((response) => {
                // take array of [[timestamp, price]] and convert to dates then filter to 2023
                let prices = response.data.prices
                let filtered = prices.map((price) => {
                    return {date: new Date(price[0]), price: price[1]}
                }).filter((price) => {
                    return price.date.getFullYear() == 2023
                })
                this.solPrices = filtered
            })
        },
        connectEth() {
            // set local storage to select eth wallet
            console.log(this.wallet)
            this.wallet.select("Ethereum Wallet")
            // window.localStorage.setItem('walletName', 'Ethereum Wallet')
            // console.log(window.localStorage.getItem('walletName'))
            // select.select('Ethereum Wallet')
        }


    }
})
</script>

<template>

            <div class="card h-100">
                <!-- vertically and horizontally center content -->
                <div class="card-body">
                    <h3>Stake Solana Using Your Eth Wallet</h3>
                    <div class="h-100
                d-flex align-items-center justify-content-center
">                  <div v-if="wallet.connected"  class="w-100">
                        <delegate-stake class="w-100"></delegate-stake>
                        <small>Choose an amount then click delegate to start staking with Solana Compass. Your stake account will return rewards each epoch (~2 days). You can track your rewards or unstake below.</small>
                    </div>
                    <div class="text-center" v-else>
                        <div><img src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Ethereum-icon-purple.svg/512px-Ethereum-icon-purple.svg.png?20200227011040" style="height:150px; width:150px"  @click="connectEth"></div>
                        <h4>Connect your wallet to bridge</h4>
                    <button class="btn btn-primary btn-xl mx-auto" @click="connectEth">Connect Eth Wallet</button>
                    </div>
                </div>
                </div>
            </div>

</template>

<style scoped>

</style>
